import { render, staticRenderFns } from "./PropertySummary.vue?vue&type=template&id=194eaf4a&scoped=true&"
import script from "./PropertySummary.vue?vue&type=script&lang=js&"
export * from "./PropertySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194eaf4a",
  null
  
)

export default component.exports